import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * Tool Service
 */
class ToolService extends BaseService {
  constructor() {
    super('tool');
  }

  /**
   * List all tools
   * @returns {Promise}
   */
  async getAllTools() {
    try {
      const response = await apiClient.get('/tool');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Create a new tool
   * @param {Object} toolData - Tool data
   * @returns {Promise}
   */
  async createTool(toolData) {
    try {
      const response = await apiClient.post('/tool', toolData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get tool details
   * @param {string} id - Tool ID
   * @returns {Promise}
   */
  async getToolById(id) {
    try {
      const response = await apiClient.get(`/tool/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete tool
   * @param {string} id - Tool ID
   * @returns {Promise}
   */
  async deleteTool(id) {
    try {
      const response = await apiClient.delete(`/tool/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new ToolService();
